// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bhr_j bhr_i bhr_bc bhr_r bhr_st","QualityCheckboxes__quality":"ex_b"};